const getUtmParams = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const utmParams = {};
    params.forEach((value, key) => { if(key.startsWith("utm_")){ utmParams[key] = value; } });
    return utmParams;
  } catch (err) {
    console.error("Could not parse UTM params:", err);
    return {};
  }
};

export const trackEvent = async (eventName, org_id, event_id, eventData = {}, demographics = {}) => {
	if( !org_id ){ return; }

	// We don't want to crash the app if analytics fails
	try {
		const browserData = {
			userAgent: navigator.userAgent,
			screenWidth: window.screen.width,
			screenHeight: window.screen.height,
			viewportWidth: window.innerWidth,
			viewportHeight: window.innerHeight,
			language: navigator.language,
			page_title: document.title
		};

		let referrer = null;
    let referringDomain = null;

    if (document.referrer && document.referrer !== "") {
			try {
				referrer = document.referrer.split('?')[0];
				referringDomain = new URL(referrer).hostname;

				if (referringDomain.startsWith('www.')){ referringDomain = referringDomain.substring(4); }

			} catch (e) {
				// Fallback in case document.referrer is a malformed URL
				console.error("Could not parse referrer URL:", e);
				referrer = document.referrer; 
			}
		} 

		let networkConnection = null

		if( navigator.connection && navigator.connection.effectiveType != ''){
			try {
				networkConnection = navigator.connection.effectiveType;
			} catch (e) {
				console.error("Could not parse network_connection:", e);
			}
		}

		const utmParams = getUtmParams();

		const demographics = {};

		if(eventData.page_path && typeof eventData.page_path === 'string'){ eventData.page_path = eventData.page_path.split('?')[0]; }

		const payload = {
			event_name: eventName,
			org_id: org_id,
			event_id: event_id || null,
			timestamp: Date.now(),
			referrer: referrer,
			referrer_domain: referringDomain,
			network_connection: networkConnection,
			...utmParams,
			...browserData,
			...demographics,
			...eventData,
		};

		// 5. Firehose needs data as a special "Uint8Array" (raw bytes)
		const data_fetch = await fetch('/api/analytics', {
	      method: 'POST',
	      headers: { 'Content-Type': 'application/json' },
	      body: JSON.stringify(payload),
	    });
	} catch (err) {
		// Log the error for debugging, but don't bother the user
		console.error("Analytics tracking error:", err);
	}
};